// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__34YM4","emails":"CreateEditClinics_emails__2luKg","emailTagLabel":"CreateEditClinics_emailTagLabel__3S_Lh"};